<template>
  <div>
    <v-btn icon flat color="success" @click="editLogo" class="mx-1" v-if="accesses.logo_update"><v-icon>mdi-pencil</v-icon></v-btn>
    <v-btn icon flat color="error" @click="deleteLogo" class="mx-1" v-if="accesses.logo_delete" :disabled="data.parent_id==='c_' || data.logo.inherited===true"><v-icon>mdi-delete</v-icon></v-btn>
  </div>
</template>

<script>
  import LogoForm from './LogoForm'
  
  export default {
    name : "LogoButtons",
  
    components:{
      LogoForm
    },
    
    props: {
      data: {
        type: Object,
        required: true,
      }
    },
    
    computed:{
      accesses(){
        return this.$store.state.app.account.accesses['orgstructure'] || {}
      }
    },
    
    methods:{
      editLogo(){
        this.$bus.$emit('logo.button', {type:'edit', data: this.data})
      },
  
      deleteLogo(){
        this.$bus.$emit('logo.button', {type:'delete', data: this.data})
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Logo/LogoButtons.vue